import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TestTypeStorageService {
  private testConfig: any = null;

  public getTestConfig(): any {
    return this.testConfig;
  }

  public setTestConfig(value: any): void {
    this.testConfig = value;
  }

  public resetConfig(): void {
    this.testConfig = null;
  }
}
